import SmoothScroll from "smooth-scroll";

let targetContent = null;

var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
});

function closeModal() {
  const modalClose = document.getElementById("close-modal");
  const modal = document.getElementById("modal");

  modalClose &&
    modalClose.addEventListener("click", function () {
      this.parentNode.parentNode.parentNode.classList.remove("active");
      targetContent.classList.remove("active");
    });

  modal &&
    modal.addEventListener("click", function (e) {
      if (!e.target.closest(".modal-content")) {
        this.classList.remove("active");
        targetContent.classList.remove("active");
      }
    });
}

function displayModal() {
  const INTERVIEW_ITEM_CLASS = ".interview__item";

  const modal = document.getElementById("modal");
  const interviews = document.getElementById("interviews");
  const toMessage = document.getElementById("go-to-message");

  interviews &&
    interviews.addEventListener("click", function (e) {
      const hasTarget = e.target.closest(INTERVIEW_ITEM_CLASS);

      if (!hasTarget) return;

      const targetId = hasTarget.dataset.for;
      targetContent = document.getElementById(targetId);
      modal.classList.add("active");
      targetContent.classList.add("active");
    });

  toMessage &&
    toMessage.addEventListener("click", function () {
      targetContent = document.getElementById("message");
      modal.classList.add("active");
      targetContent.classList.add("active");
    });

  closeModal();
}

function changeRecruitContent() {
  const RECRUIT_ITEM_CLASS = ".recruit__item";
  
  const recruits = document.getElementById("recruit-content");

  recruits &&
    recruits.addEventListener("click", function (e) {
      const hasTarget = e.target.closest(RECRUIT_ITEM_CLASS);

      if (!hasTarget) return;

      const targetId = hasTarget.dataset.for;
      const contents = document.querySelectorAll(".des-content");
      contents.forEach((e) => {
        e.classList.remove("active");
      });
      const recruitItems = recruits.querySelectorAll(RECRUIT_ITEM_CLASS);
      recruitItems.forEach((e) => {
        e.classList.remove("active");
      });
      hasTarget.classList.add("active");
      const target = document.getElementById(targetId);
      target.classList.add("active");
    });

  const recruitSp = document.getElementById("recruit-sp");

  recruitSp &&
    recruitSp.addEventListener("click", function (e) {
      const item = e.target.closest(".item");
      if (!item) return;
      const content = item.querySelector(".item__content");
      
      if ([...content.classList].includes("on")) {
        content.classList.remove("on");
      } else {
        content.classList.add("on");
      }
    });
}

changeRecruitContent();
displayModal();
